import React from "react";

import Overview from "./manage/Overview";
import DashboardLevels from "./DashboardLevels";
import Add from "./manage/Add";
import Edit from "./manage/Edit";
import DashboardLevel from "./manage/DashboardLevel";

import { ClimateProvider } from "../../context/ClimateContext";
import { EthnicGroupProvider } from "../../context/EthnicGroupContext";
import { LanguageProvider } from "../../context/LanguageContext";
import { ReligionProvider } from "../../context/ReligionContext";

import {
  FirstLevelProvider,
  SecondLevelProvider,
  ThirdLevelProvider,
  FourthLevelProvider,
  DashboardLevelProvider,
} from "../../context/levels";

export const LevelsDashboard = () => {
  return (
    
      <DashboardLevels />
    
  );
};

export const Levels = () => {
  return (
    <FirstLevelProvider>
      <SecondLevelProvider>
        <ThirdLevelProvider>
          <FourthLevelProvider>
            <Overview />
          </FourthLevelProvider>
        </ThirdLevelProvider>
      </SecondLevelProvider>
    </FirstLevelProvider>
  );
};

export const LevelDashboard = () => {
  return (
    <DashboardLevelProvider>
      <DashboardLevel />
    </DashboardLevelProvider>
  );
};

export const AddLevel = () => {
  return (
    <ClimateProvider>
      <EthnicGroupProvider>
        <ReligionProvider>
          <LanguageProvider>
            
              <FirstLevelProvider>
                <SecondLevelProvider>
                  <ThirdLevelProvider>
                    <FourthLevelProvider>
                      <Add />
                    </FourthLevelProvider>
                  </ThirdLevelProvider>
                </SecondLevelProvider>
              </FirstLevelProvider>
            
          </LanguageProvider>
        </ReligionProvider>
      </EthnicGroupProvider>
    </ClimateProvider>
  );
};

export const EditLevel = () => {
  return (
    <ClimateProvider>
      <EthnicGroupProvider>
        <ReligionProvider>
          <LanguageProvider>
            
              <FirstLevelProvider>
                <SecondLevelProvider>
                  <ThirdLevelProvider>
                    <FourthLevelProvider>
                      <Edit />
                    </FourthLevelProvider>
                  </ThirdLevelProvider>
                </SecondLevelProvider>
              </FirstLevelProvider>
            
          </LanguageProvider>
        </ReligionProvider>
      </EthnicGroupProvider>
    </ClimateProvider>
  );
};
